export const LOCALE_PREFIX = 'scenes.Gnosus.components.GroupStack.components.Header.components.ButtonsArea'

export const BUTTONS = {
    IMPORT: 'import',
    XLS: 'xls',
    MONITORING: 'monitoring',
    DELETE: 'delete',
    FILTER: 'filter',
}
